import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import { Button, CardActionArea, CardActions } from '@mui/material'
import Fade from 'Components/Transitions/Fade'

export default function MultiActionAreaCard() {
  return (
    <Fade
      timeout={3000}
      sensorProps={{
        partialVisibility: true,
      }}>
      <Card sx={{ maxWidth: 345, height: '100%' }}>
        <CardActionArea>
          <CardMedia
            component='img'
            image='https://s3.us-west-2.amazonaws.com/www.tenspacesoftware.com/images/_77093409-36ed-4cae-b2a5-203b1851a0d8.jpg'
            alt='Robot Front Center'
          />
          <CardContent>
            <Typography gutterBottom variant='h5' component='div'>
              Software Development
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              We only program using the latest technology. React, AWS microservices and serverless
              techology, CI/CD pipelines for continuos delivery, various types of databases and
              datastores, artifical intelligence, and much more.
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size='small' color='primary'>
            Share
          </Button>
        </CardActions>
      </Card>
    </Fade>
  )
}
